import { ApiRequestError } from "@/api/util";

const CLE_UPLOAD_ERROR_MESSAGES: Record<string, string> = {
  DOCUMENT_ALREADY_EXISTS: "Denne fil er allerede uploadet.",
  ATTACHMENT_ALREADY_EXISTS: "Denne fil er allerede vedhæftet kursusbeviset.",
  UNSUPPORTED_FILE_TYPE: "Filen skal være en PDF.",
  FILE_TOO_LARGE: "Filen er for stor.",
};

const parseErrorPayload = (data: unknown): { code?: string } | null => {
  if (typeof data === "string") {
    try {
      const parsed = JSON.parse(data) as unknown;
      return typeof parsed === "object" && parsed !== null
        ? (parsed as { code?: string })
        : null;
    } catch {
      return null;
    }
  }

  if (typeof data === "object" && data !== null) {
    return data as { code?: string };
  }

  return null;
};

const extractErrorCode = (error: unknown): string | null => {
  if (!(error instanceof ApiRequestError)) {
    return null;
  }

  const payload = parseErrorPayload(error.data);
  const code = payload?.code;
  return typeof code === "string" ? code : null;
};

export const getCleUploadErrorMessage = (
  error: unknown,
  fallback: string,
): string => {
  const code = extractErrorCode(error);

  if (code && code in CLE_UPLOAD_ERROR_MESSAGES) {
    return CLE_UPLOAD_ERROR_MESSAGES[code];
  }

  return fallback;
};
